import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {plainToClass} from 'class-transformer';
import {environment} from '../../../environments/environment';
import {SupportRequestAttachmentApiModel} from '../models/support-request-attachment.api-model';

@Injectable({providedIn: 'root'})
export class SupportRequestAttachmentRestService {
  private readonly resource = '/support_request_attachments';
  constructor(private readonly http: HttpClient) {}
  public get(id: string): Observable<SupportRequestAttachmentApiModel> { return this.http.get<SupportRequestAttachmentApiModel>(environment.apiUrl + id).pipe(map(response => plainToClass(SupportRequestAttachmentApiModel, response))); }
  public uploadWithProgress(file: File): Observable<number | SupportRequestAttachmentApiModel> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<SupportRequestAttachmentApiModel>(environment.apiUrl + this.resource, formData, {reportProgress: true, observe: 'events'}).pipe(map(event => {
      if (event.type === HttpEventType.UploadProgress) return Math.round((event.loaded / (event.total || 1)) * 100);
      if (event.type === HttpEventType.Response) return plainToClass(SupportRequestAttachmentApiModel, event.body);
      return 0;
    }));
  }
}
